export default __webpack_public_path__ + "static/media/IkonSparegris.1e392c32.svg";